import { BusinessUnitsTableDataQuery } from 'src/apps/dashboard/services/queries/business-units-table/BusinessUnitsTable.generated';
import { BusinessUnitsTableData } from 'src/apps/dashboard/services/queries/business-units-table/BusinessUnitsTable.gql';
import { buildBusinessUnitsTableVariables } from 'src/apps/dashboard/services/queries/business-units-table/helpers/buildVariables';
import {
	BusinessUnitsTableResult,
	EMPTY_SUMMARY,
	transformBusinessUnitsTableResults
} from 'src/apps/dashboard/services/queries/business-units-table/helpers/transformConsolidatedResults';
import { BusinessUnit } from 'src/apps/dashboard/types/DashboardTypes';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { gqlClient } from 'src/common/services/api/GraphQLRequestApi';
import { Logger } from 'src/common/services/Logger';

interface IGetBusinessUnitsTableDataParams {
	days: number;
	businessUnits: BusinessUnit[];
	filters?: IFilterOptions;
}

export const getBusinessUnitsTableData = async ({
	days,
	businessUnits,
	filters
}: IGetBusinessUnitsTableDataParams): Promise<BusinessUnitsTableResult> => {
	try {
		const variables = buildBusinessUnitsTableVariables({
			days,
			filters
		});

		const result = await gqlClient.request<BusinessUnitsTableDataQuery>(
			BusinessUnitsTableData,
			variables
		);

		const transformedResult = transformBusinessUnitsTableResults(result, businessUnits, days);

		return {
			rows: transformedResult.rows,
			total: transformedResult.rows.length,
			unfilteredTotal: transformedResult.unfilteredTotal,
			scoreWebProducts: transformedResult.scoreWebProducts,
			aggregatedScoreWebProducts: transformedResult.aggregatedScoreWebProducts,
			aggregatedScoreDeltas: transformedResult.aggregatedScoreDeltas,
			summaryUniqueIssues: transformedResult.summaryUniqueIssues,
			summaryTotalIssues: transformedResult.summaryTotalIssues
		};
	} catch (error) {
		Logger.error(
			'BusinessUnitsTableService -> getBusinessUnitsTableData failed with an error:',
			error
		);
		return {
			rows: [],
			total: 0,
			unfilteredTotal: 0,
			scoreWebProducts: [],
			aggregatedScoreWebProducts: [],
			aggregatedScoreDeltas: [],
			summaryUniqueIssues: EMPTY_SUMMARY,
			summaryTotalIssues: EMPTY_SUMMARY
		};
	}
};
